<script setup>
const props = defineProps(['type', 'contactUrl'])
</script>

<template>
    <div :class="`field--message field--message__${type}`" role="alert">
        <slot />

        <p v-if="contactUrl"><a :href="contactUrl" class="whippet-button style--filled color--navy">Contact us</a></p>
    </div>
</template>
